module.exports = __webpack_public_path__ + "fonts/084aab0e2294fb3e782b9a74da65be67.txt";